import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Container, Image, Row, Col, Button, Card } from 'react-bootstrap'

import { FreeMode, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data } = this.props

    if(ajax_data != null && 'collections_ng' in ajax_data) return (
      <div className={styles.collectionsng}>
        <Container>
          <div className='w-100 d-flex justify-content-between align-items-end'>
            <div className={styles.collectionsng_title}>КОЛЛЕКЦИИ</div>
            <a href={page_data.man_link} className={styles.collectionsng_all}>Смотреть все →</a>
          </div>
          {ajax_data.collections_ng.map(( elm, key ) => {
            if(key == 0) return (
              <Row key={key} className={styles.collectionsng_content + ` d-none d-lg-flex`}>
                <Col lg={4}>
                  <Card className={styles.collectionsng_card}>
                    <Card.Img alt={elm.title} className={styles.collectionsng_card_img} src={elm.photo1} width={436} height={657} />
                    <Card.ImgOverlay className={styles.collectionsng_card_content}>
                      <div>
                        <div className={styles.collectionsng_card_title}>{elm.title}</div>
                        {elm.link != '' &&
                          <Button href={elm.link} className={styles.collectionsng_card_btn + ` stretched-link`} variant="light">Купить</Button>
                        }
                      </div>
                    </Card.ImgOverlay>
                  </Card>
                </Col>
                <Col lg={4}>
                  <Card className={styles.collectionsng_card}>
                    <Card.Img alt={elm.title2} className={styles.collectionsng_card_img} src={elm.photo2} width={436} height={657} />
                    <Card.ImgOverlay className={styles.collectionsng_card_content}>
                      <div>
                        <div className={styles.collectionsng_card_title}>{elm.title2}</div>
                        {elm.link2 != '' &&
                          <Button href={elm.link2} className={styles.collectionsng_card_btn + ` stretched-link`} variant="light">Купить</Button>
                        }
                      </div>
                    </Card.ImgOverlay>
                  </Card>
                </Col>
                <Col lg={4}>
                  <div className='h-100 d-flex flex-column justify-content-between'>
                    <Card className={styles.collectionsng_card}>
                      <Card.Img alt={elm.title3} className={styles.collectionsng_card_img} src={elm.photo3} width={436} height={326} />
                      <Card.ImgOverlay className={styles.collectionsng_card_content}>
                        <div>
                          <div className={styles.collectionsng_card_title}>{elm.title3}</div>
                          {elm.link3 != '' &&
                            <Button href={elm.link3} className={styles.collectionsng_card_btn + ` stretched-link`} variant="light">Купить</Button>
                          }
                        </div>
                      </Card.ImgOverlay>
                    </Card>
                    <Card className={styles.collectionsng_card}>
                      <Card.Img alt={elm.title4} className={styles.collectionsng_card_img} src={elm.photo4} width={436} height={326} />
                      <Card.ImgOverlay className={styles.collectionsng_card_content}>
                        <div>
                          <div className={styles.collectionsng_card_title}>{elm.title4}</div>
                          {elm.link4 != '' &&
                            <Button href={elm.link4} className={styles.collectionsng_card_btn + ` stretched-link`} variant="light">Купить</Button>
                          }
                        </div>
                      </Card.ImgOverlay>
                    </Card>
                    {/*
                      <Image className={styles.collectionsng_card_img} src={elm.photo3} width={436} height={326} />
                      <Image className={styles.collectionsng_card_img} src={elm.photo4} width={436} height={326} />
                    */}
                  </div>
                </Col>
              </Row>
            )
          })}
          <Swiper
            modules={[FreeMode, Pagination]}
            pagination={{ type: `progressbar` }}
            spaceBetween={10}
            slidesPerView={`auto`}
            freeMode={true}
            className={styles.collectionsng_content + ` d-lg-none`}
            speed={300}
          >
            {ajax_data.collections_ng.map(( elm, key ) => {
              return (
                <SwiperSlide key={key} className={styles.collectionsng_card_w}>
                  <Card className={styles.collectionsng_card}>
                    <Card.Img alt={elm.title} className={styles.collectionsng_card_img} src={elm.photo1} width={436} height={657} />
                    <Card.ImgOverlay className={styles.collectionsng_card_content}>
                      <div>
                        <div className={styles.collectionsng_card_title}>{elm.title}</div>
                        <Button href={elm.link} className={styles.collectionsng_card_btn + ` stretched-link`} variant="light">Купить</Button>
                      </div>
                    </Card.ImgOverlay>
                  </Card>
                </SwiperSlide>
              )
            })}
            <SwiperSlide className={styles.collectionsng_card_w_last}></SwiperSlide>
          </Swiper>
        </Container>
      </div>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object
}